// socket.ts
import { io } from "socket.io-client";
import { SOCKET_URL } from "./config";

let clientSocket: ReturnType<typeof io> | null = null;
let adminSocket: ReturnType<typeof io> | null = null;

// Get the correct socket - for admin namespace, return admin socket; for client namespace, return client socket
export const getSocket = () => {
  // Prioritize admin socket if it exists (for admin pages)
  if (adminSocket?.connected) return adminSocket;
  if (clientSocket?.connected) return clientSocket;
  // Fallback if one is not connected yet
  return adminSocket || clientSocket;
};

// Get admin socket specifically
export const getAdminSocket = () => adminSocket;

// Get client socket specifically
export const getClientSocket = () => clientSocket;

// Ensure client socket is connected
export const connectClientSocket = () => {
  if (typeof window === 'undefined') return;

  const token = localStorage.getItem('token');
  if (!token) return;

  if (!clientSocket || !clientSocket.connected) {
    console.log('🔌 Creating new CLIENT SOCKET connection to', SOCKET_URL);
    clientSocket = io(SOCKET_URL, {
      auth: { token },
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      path: '/socket.io',
    });

    clientSocket.on('connect', () => {
      console.log(`
╔════════════════════════════════════════════════════════════╗
║ ✅ CLIENT SOCKET CONNECTED                                 ║
║ Socket ID: ${clientSocket?.id}
║ Namespace: default (/)
║ Timestamp: ${new Date().toISOString()}
╚════════════════════════════════════════════════════════════╝`);
    });

    clientSocket.on('disconnect', () => {
      console.log('❌ CLIENT SOCKET DISCONNECTED');
    });

    clientSocket.on('connect_error', (error) => {
      console.error('⚠️ CLIENT SOCKET CONNECTION ERROR:', error);
    });
  }

  return clientSocket;
};

// Connect both client and admin sockets (admin pages need both)
export const connectAdminSocket = () => {
  if (typeof window === 'undefined') return;

  const token = localStorage.getItem('token');
  if (!token) return;

  // Connect admin namespace socket
  if (!adminSocket || !adminSocket.connected) {
    console.log('🔌 Creating new ADMIN SOCKET connection to', SOCKET_URL + '/admin');
    adminSocket = io(SOCKET_URL + '/admin', {
      auth: { token },
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      path: '/socket.io',
    });

    adminSocket.on('connect', () => {
      console.log(`
╔════════════════════════════════════════════════════════════╗
║ ✅ ADMIN SOCKET CONNECTED                                  ║
║ Socket ID: ${adminSocket?.id}
║ Namespace: /admin
║ Timestamp: ${new Date().toISOString()}
╚════════════════════════════════════════════════════════════╝`);
    });

    adminSocket.on('disconnect', () => {
      console.log('❌ ADMIN SOCKET DISCONNECTED');
    });

    adminSocket.on('connect_error', (error) => {
      console.error('⚠️ ADMIN SOCKET CONNECTION ERROR:', error);
    });
  }

  // Also ensure default (client) socket is connected
  if (!clientSocket || !clientSocket.connected) {
    console.log('🔌 Creating new CLIENT SOCKET connection to', SOCKET_URL);
    clientSocket = io(SOCKET_URL, {
      auth: { token },
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      path: '/socket.io',
    });

    clientSocket.on('connect', () => {
      console.log(`
╔════════════════════════════════════════════════════════════╗
║ ✅ CLIENT SOCKET CONNECTED                                 ║
║ Socket ID: ${clientSocket?.id}
║ Namespace: default (/)
║ Timestamp: ${new Date().toISOString()}
╚════════════════════════════════════════════════════════════╝`);
    });

    clientSocket.on('disconnect', () => {
      console.log('❌ CLIENT SOCKET DISCONNECTED');
    });

    clientSocket.on('connect_error', (error) => {
      console.error('⚠️ CLIENT SOCKET CONNECTION ERROR:', error);
    });
  }

  return { adminSocket, clientSocket };
};

export const disconnectAdminSocket = () => {
  adminSocket?.disconnect();
  adminSocket = null;
  clientSocket?.disconnect();
  clientSocket = null;
};
